<template>
    <div class="file-record" :class="[type]" @click="download">
        <div class="file-record-content">
            <div class="file-record-title">{{title || fileName(url)}}</div>
            <div class="file-record-size">{{size}}</div>
        </div>
        <div class="file-record-img">
            <img class="" :src="fileIcon(fileType)">
            <!-- <i class="el-icon-document"></i> -->
        </div>
    </div>
</template>
<script>
import { downloadFile,downloadFileByHttp } from '../../../utils/common'
export default {
    props: {
        title: {
            type: String
        },
        size: {
            type: String
        },
        url: {
            type: String
        },
        type: {
            type: String,
            default() { return 'left' },
            validator: s => ['left', 'right'].includes(s)
        },
        fileType: {
            type: String,
            default() {
                return ''
            }
        }
    },
    computed: {
        fileIcon: () => (type) => {
            switch(type){
                case 'ppt':
                case 'pptx':
                    return require('/src/assets/chatLog/ppt.png')
                case 'doc':
                case 'docx':
                    return require('/src/assets/chatLog/word.png')
                case 'xls':
                case 'xlsx':
                    return require('/src/assets/chatLog/excel.png')
                case 'pdf':
                    return require('/src/assets/chatLog/pdf.png')
                default:
                    return require('/src/assets/chatLog/other.png')
            }
        },
        fileName() {
            return function(url) {
                if(!url) return ''
                let index = url.lastIndexOf('/')
                return url.slice(index+1)
            }
        }
    },
    methods: {
        download() {
            if(this.fileType=='pdf') {
                downloadFileByHttp(this.url,this.title)
            }else {
                downloadFile(this.url, this.title)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.file-record {
    display: flex;
    flex-direction: row;
    width: 180px;
    cursor: pointer;
    &-content {
        width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 60px;
        margin-right: 4px;
        font-size: 13px;
    }
    &-title {
        //  white-space: nowrap;
            /* 超出范围隐藏 */
            padding-top: 6px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient:vertical ;
        /* 文字超出用省略号 */
        text-overflow: ellipsis;
        // color: #fff;
    }
    &-size {
        flex: 1;
        padding-top: 6px;
        font-size: 12px;
        color: rgb(172, 171, 171);
    }
    &-img {
        display: flex;
        align-items: center;
        font-size: 26px;
        img {
            width: 42px;
            height: 44px;
            border-radius: 0 !important;
        }
    }
    // 左边三角
    &.left {
        font-size: 14px;
        padding: 7px 10px;
        border-radius: 6px;
        background: #fff;
        position: relative;
        margin-top: 5px;
        &::before {
            position: absolute;
            left: -8px;
            top: 50%;
            transform: translate(0, -50%);
            content: "";
            border-right: 10px solid #fff;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
        }
    }
    // 右边三角
    &.right {
        padding: 7px 10px;
        border-radius: 6px;
        font-size: 14px;
        top: 0;
        right: 0;
        margin-right: 10px;
        position: relative;
        margin-top: 5px;
        background: #fff;
        text-align: left;
        &::after {
            position: absolute;
            right: -8px;
            top: 50%;
            transform: translate(0,-50%);
            content: "";
            border-left: 10px solid #fff;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
        }
    }
}
</style>